import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
  SiExpo, // Import Expo icon
  SiInsomnia, // Placeholder for Thunder Client (since no official icon exists)
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiExpo /> {/* Expo icon */}
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiInsomnia /> 
      </Col>
    </Row>
  );
}

export default Toolstack;
